import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/App/actions';
import HorizontalMenu from 'components/Menus/HorizontalMenu';
import Profile from './Profile';
import Billing from '../Billing';
import AccountSettings from './Settings';
import LinkedAccounts from './LinkedAccounts';
import './account.scss';

const ACCOUNT = 'account';
const SETTINGS = 'settings';
const BILLING = 'billing';
const LINKED_ACCOUNTS = 'linked-accounts';

const Account = () => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const userInfoErrors = useSelector((state) => state.global.userInfoErrors);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { activeTab } = useParams();
  const {
    updateUserInfo,
    getNotificationPreferences,
    saveNotificationPreferences,
  } = bindActionCreators(actions, dispatch);

  const getAccountTab = () => {
    switch (activeTab) {
      case 'settings':
        return SETTINGS;
      case 'billing':
        return BILLING;
      case 'linked-accounts':
        return LINKED_ACCOUNTS;
      default:
        return ACCOUNT;
    }
  };

  const [accountTab, setAccountTab] = useState(getAccountTab());

  const history = useHistory();

  const tabs = [
    {
      id: 'profile',
      name: 'User profile',
      onClick: () => {
        setAccountTab(ACCOUNT);
        history.push('/app/v2/account');
      },
      active: accountTab === ACCOUNT,
    },
    {
      id: 'notifications',
      name: 'Notifications',
      onClick: () => {
        setAccountTab(SETTINGS);
        history.push('/app/v2/account/settings');
      },
      active: accountTab === SETTINGS,
    },
    {
      id: 'linked-accounts',
      name: 'Linked Accounts',
      onClick: () => {
        setAccountTab(LINKED_ACCOUNTS);
        history.push('/app/v2/account/linked-accounts');
      },
      active: accountTab === LINKED_ACCOUNTS,
    },
    {
      id: 'billing',
      name: 'Subscriptions & Billing',
      onClick: () => {
        setAccountTab(BILLING);
        history.push('/app/v2/account/billing');
      },
      active: accountTab === BILLING,
    },
  ];

  return (
    <div>
      <div className="content-container account-container">
        <div className="page-title">
          <h1 className="title">My Account</h1>
        </div>
        <HorizontalMenu items={tabs} />
        {accountTab === ACCOUNT && (
          <Profile
            userInfo={userInfo}
            updateUserInfo={updateUserInfo}
            userInfoErrors={userInfoErrors}
            loading={loading}
            setLoading={setLoading}
          />
        )}
        {accountTab === BILLING && <Billing />}
        {accountTab === SETTINGS && (
          <AccountSettings
            getNotificationPreferences={getNotificationPreferences}
            saveNotificationPreferences={saveNotificationPreferences}
          />
        )}
        {accountTab === LINKED_ACCOUNTS && <LinkedAccounts />}
      </div>
    </div>
  );
};

export default Account;
